import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../services/api.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { getTenderOpeningSheetTemplate } from '../../pre-ready-tepmlate';

interface TenderOpeningSheetRow {
  slNo: number;
  bidderName: string;
  bidReference: string;
  contact: string;
  phone_number: string;
  documentsSubmitted: string;
  remarks: string;
}

@Component({
  selector: 'app-revenue-bid',
  standalone: false,
  templateUrl: './revenue-bid.component.html',
  styleUrl: './revenue-bid.component.scss',
})
export class RevenueBidComponent implements OnInit {
  @Output() routeConfig = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  @Input() schemeType: string;
  @Input() proposalName: any;
  @Input() id: any;
  @Input() format: any;
  @Input() proposalId: any;
  @Input() url: String = '';
  userID: any;
  baseUrl = environment.APIUrl;
  private subscriptions = new Subscription();
  docuemntList: any;
  winners: any;
  uploadedFiles: any[] = [];
  technicalEvaluationId: number | null = null; // Store the id from API response
  mode_tendor: string | null = null; // Limited Tender, Open Tender, Single Tender

  // R-TEC specific fields
  meeting_date: string = '';
  meeting_time: string = '';
  meeting_venue: string = '';
  tec_approval: string = '';
  userRoleCode: string = '';

  // Tender Opening Sheet API fields
  bid_submission_date: string = '';
  rfp_to_date: string = '';
  rfp_to_time: string = '';

  // Firm capacity required flag
  firmCapacityRequired: string = 'yes';

  // Tender Opening Sheet data
  tenderOpeningSheetData: TenderOpeningSheetRow[] = [];

  // TinyMCE Editor for Tender Opening Sheet
  init: EditorComponent['init'] = init;
  tenderSheetEditorData: string = '';
  tenderSheetResponse: any = null;

  constructor(
    private messageService: MessageService,
    private apiService: ApiService
  ) {
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
    this.userRoleCode = sessionStorage.getItem('user_role_code') || '';
  }

  ngOnInit() {
    this.getData();
    console.log('knkkmkmkmk', this.url, this.stepDetails)
    console.log('Step Code:', this.stepDetails?.code, 'User Role Code:', this.userRoleCode, 'Is R-TEC:', this.isRtecUser);
  }




  getData() {
    let url = `/revenue/technical-evaluation/?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`;
    const sub = this.apiService.getAPI(url).subscribe((resp: any) => {
      this.docuemntList = resp;

      // Store the id from API response
      this.technicalEvaluationId = resp.id || null;
      this.tenderSheetResponse = resp;

      // Set mode of tender from API response (Qualify/Disqualify only for Limited & Open Tender)
      this.mode_tendor = resp.mode_tendor ?? null;

      // Set R-TEC specific fields from API response
      this.meeting_date = resp.meeting_date || '';
      this.meeting_time = resp.meeting_time || '';
      this.meeting_venue = resp.meeting_venue || '';
      this.tec_approval = resp.tec_approval || '';

      // Load firm capacity required flag from API response
      if (resp.step_capacity) {
        this.firmCapacityRequired = resp.step_capacity;
      }

      // Store tender opening sheet fields
      this.bid_submission_date = resp.bid_submission_date || '';
      this.rfp_to_date = resp.rfp_to_date || '';
      this.rfp_to_time = resp.rfp_to_time || '';

      // Convert vendors object -> array
      this.winners = Object.keys(resp.vendors || {}).map((vendorName) => {
        const vendorEntries = resp.vendors[vendorName] || [];

        // Take vendor details from first entry
        const vendorDetails = vendorEntries[0]?.vendor || { name: vendorName };
        const vendorStatus = vendorEntries[0]?.vendor_status || null;

        // Map uploaded documents (from `documents` array)
        const documents = vendorEntries
          .flatMap((entry) => entry.documents || []) // flatten all documents for this vendor
          .map((docPath) => ({
            filePath: docPath,
            fileName: docPath.split('/').pop(),
          }));
        let displayStatus = null;
        if (vendorStatus === 'Qualify') {
          displayStatus = 'Qualified';
        } else if (vendorStatus === 'Disqualify') {
          displayStatus = 'Disqualified';
        } else {
          displayStatus = vendorStatus; // fallback
        }

        return {
          vendor: vendorDetails,
          vendor_status: displayStatus,
          documents: documents,
          remark: vendorEntries[0]?.remark || null,
          rawEntries: vendorEntries, // keep reference if needed later
        };
      });

      // Populate Tender Opening Sheet data
      this.tenderOpeningSheetData = this.winners.map((winner: any, index: number) => ({
        slNo: index + 1,
        bidderName: winner.vendor.name || '-',
        bidReference: winner.vendor.bid_reference || '-',
        contact: winner.vendor.contact || '-',
        phone_number: winner.vendor.phone_number || '-',
        documentsSubmitted: winner.documents.length > 0
          ? winner.documents.map((doc: any) => doc.fileName).join(', ')
          : 'No documents submitted',
        remarks: winner.vendor_status || 'Pending review'
      }));

      // Load Tender Opening Sheet from justification or generate template
      if (resp.justification) {
        this.tenderSheetEditorData = resp.justification;
      } else {
        this.tenderSheetEditorData = this.buildTenderSheetWithVendors();
      }
    });
    this.subscriptions.add(sub);
  }


  setStatus(vendor: any, status: 'Qualify' | 'Disqualify') {
    console.log(vendor);
    vendor.vendor_status = status;
    const formData = new FormData();
    formData.append('vendor_status', vendor.vendor_status);
    formData.append('vendor_eval_id', vendor.rawEntries[0].id);
    if (status === 'Disqualify' && vendor.remark) {
      formData.append('remark', vendor.remark);
    }

    const sub = this.apiService
      .putAPI(`/revenue/technical-evaluation/`, formData)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Vendor updated successfully',
          });
          this.getData(); // refresh the table
        },
        error: (err) => { },
      });
    this.subscriptions.add(sub);
  }

  // Save remark for a disqualified vendor
  saveRemark(vendor: any) {
    const formData = new FormData();
    formData.append('vendor_eval_id', vendor.rawEntries[0].id);
    formData.append('vendor_status', 'Disqualify');
    formData.append('remark', vendor.remark || '');

    const sub = this.apiService
      .putAPI(`/revenue/technical-evaluation/`, formData)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Remark saved successfully',
          });
          this.getData();
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save remark',
          });
        },
      });
    this.subscriptions.add(sub);
  }

  // Update R-TEC specific fields
  updateTecFields() {
    const formData = new FormData();
    // Use the id from API response instead of stepDetails.id
    if (this.technicalEvaluationId) {
      formData.append('id', this.technicalEvaluationId.toString());
    }
    formData.append('meeting_date', this.meeting_date || '');
    formData.append('meeting_time', this.meeting_time || '');
    formData.append('meeting_venue', this.meeting_venue || '');
    formData.append('tec_approval', this.tec_approval || '');
    formData.append('step_capacity', this.firmCapacityRequired || 'yes');

    const sub = this.apiService
      .putAPI(`/revenue/technical-evaluation/${this.technicalEvaluationId}/`, formData)
      .subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Meeting details updated successfully',
          });
          this.getData(); // refresh the data
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update meeting details',
          });
        },
      });
    this.subscriptions.add(sub);
  }

  // Show Qualify/Disqualify only for Limited Tender and Open Tender (not Single Tender)
  get showQualifyDisqualifyButtons(): boolean {
    if (!this.mode_tendor) return false;
    const mode = (this.mode_tendor || '').trim();
    return mode === 'Limited Tender' || mode === 'Open Tender';
  }

  // Check if current step is R-TEC
  get isRtecUser(): boolean {
    // Check if step code is R-TEC
    const stepCode = this.stepDetails?.code;
    const isStepRtec = stepCode === 'R-TEC';
    const isUserRtec = this.userRoleCode === 'R-TEC';
    // Show if step code is R-TEC or user role is R-TEC
    return isStepRtec || isUserRtec;
  }



  // Build Tender Opening Sheet template with vendor names pre-filled in Firm Name column
  private buildTenderSheetWithVendors(): string {
    let template = getTenderOpeningSheetTemplate('Tender Opening Sheet', this.stepDetails);

    // Replace "Date / Time of Opening:" with actual rfp_to_date and rfp_to_time values
    const dateTimeStr = [this.rfp_to_date, this.rfp_to_time].filter(v => v).join(' ');
    template = template.replace(
      'Date / Time of Opening:</strong>',
      `Date / Time of Opening: ${dateTimeStr}</strong>`
    );

    // If no vendors available, return default template
    if (!this.winners || this.winners.length === 0) {
      return template;
    }

    // Generate rows with vendor names in the Firm Name column
    const vendorRows = this.winners.map((winner: any, index: number) => {
      const vendorName = winner.vendor?.name || '';
      const phoneNumber = winner.vendor?.phone_number || '';
      const bidSubmissionDate = this.bid_submission_date || '';
      return `<tr>
<td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
<td style="border: 1px solid #ddd; padding: 8px;">${vendorName}</td>
<td style="border: 1px solid #ddd; padding: 8px;">${bidSubmissionDate}</td>
<td style="border: 1px solid #ddd; padding: 8px;">&nbsp;</td>
<td style="border: 1px solid #ddd; padding: 8px;">${phoneNumber}</td>
<td style="border: 1px solid #ddd; padding: 8px;">&nbsp;</td>
<td style="border: 1px solid #ddd; padding: 8px;">&nbsp;</td>
</tr>`;
    }).join('\n');

    // Replace the default empty tbody content with vendor rows
    const tbodyContent = `<tbody>\n${vendorRows}\n</tbody>`;
    return template.replace(/<tbody>[\s\S]*?<\/tbody>/, tbodyContent);
  }

  // Save Tender Opening Sheet to API
  saveTenderSheet(): void {
    const payload = {
      justification: this.tenderSheetEditorData,
      proposal_step: this.stepDetails.id,
    };

    const handleResponse = (successMsg: string) => ({
      next: (_: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: successMsg
        });
        this.getData(); // Refresh to reload from justification
      },
      error: (err: any) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to save Tender Opening Sheet'
        });
      }
    });

    const isUpdate = !!(this.tenderSheetResponse && this.tenderSheetResponse.id);
    if (isUpdate) {
      this.apiService.putAPI(`/revenue/technical-evaluation/${this.tenderSheetResponse.id}/`, payload)
        .subscribe(handleResponse('Technical Evaluation updated successfully.'));
    } else {
      this.apiService.postAPI('/revenue/technical-evaluation/', payload)
        .subscribe(handleResponse('Technical Evaluation saved successfully.'));
    }
  }

  // Add a new table row in the editor
  addTableRow(): void {
    const newRow = `
      <tr>
        <td style="border: 1px solid #ddd; padding: 8px; text-align: center;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
        <td style="border: 1px solid #ddd; padding: 8px;"></td>
      </tr>
    `;

    // Find the closing tbody tag and insert the new row before it
    if (this.tenderSheetEditorData.includes('</tbody>')) {
      this.tenderSheetEditorData = this.tenderSheetEditorData.replace('</tbody>', newRow + '</tbody>');
    } else {
      // If no tbody exists, notify user
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please ensure the table structure is correct before adding rows.'
      });
    }
  }
}
